import { render, staticRenderFns } from "./thongtinkhachhang.vue?vue&type=template&id=612079ef&scoped=true&"
import script from "./thongtinkhachhang.vue?vue&type=script&lang=js&"
export * from "./thongtinkhachhang.vue?vue&type=script&lang=js&"
import style0 from "./thongtinkhachhang.vue?vue&type=style&index=0&id=612079ef&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../../usr/lib/node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "612079ef",
  null
  
)

export default component.exports